import API from 'services/API';

export const get = () => API.get('/anomaly/flight/airport');
